import React from 'react'
import { Link } from 'react-router-dom'
import cn from 'classnames'

import { SocialLinks } from '../../components/SocialLinks/SocialLinks'

import './Footer.scss'

export const Footer = ({ yellow }) => {
  return (
    <footer className={cn( 'page-footer', { yellow } )}>
      <Link to="/">
        COOLCATSTRON.COM
      </Link>
      <span>
        COOL CATS TRON 2021
      </span>
      <div className="links">
        <SocialLinks className="icon-link" />
      </div>
    </footer>
  )
}